export default "__VITE_ASSET__Cl7Z4xsO__"